import { ForexHistoryState } from '@/feature/TrHistory/store/interface';

export default <ForexHistoryState> {
	list: [],
	loadingCount: 0,
	isEndPage: false,
	pageSize: 25,
	pageNumber: 1,
	fromOperDay: '',
	toOperDay: '',
	id: null,
	fromRequestAmount: null,
	toRequestAmount: null,
	status: null,
	type: null,
	currency: null,
}
